<template>
  <div class="ui center aligned basic segment" style="overflow: auto;">
    <div class="ui center aligned container" style="margin:0">
      <div class="ui three stackable cards" style="margin:.1em">
        <router-link to="/searchforvehicle" class="card"><div class="content">Search for a vehicle</div></router-link>
        <router-link to="/offlineinspection" class="card"><div class="content">Start offline inspection</div></router-link>
        <router-link to="/mylastinspections" class="card"><div class="content">Show my last inspections</div></router-link>
        <router-link to="/stocklist" class="card"><div class="content">Stocklist history</div></router-link>
        <router-link to="/createstocklist" class="card"><div class="content">Start stocklist</div></router-link>
        <router-link to="/salesshoot" class="card"><div class="content">Sales photo shoot</div></router-link>
        <router-link to="/manualsalesshoot" class="card"><div class="content">Sales shoots with errors</div></router-link>
        <router-link to="/vehicleimages" class="card"><div class="content">View vehicle images</div></router-link>
        <router-link to="/vehiclein" class="card"><div class="content">Check in vehicle</div></router-link>
        <router-link to="/vehicleout" class="card"><div class="content">Check out vehicle</div></router-link>
        <router-link to="/transporterreturns" class="card"><div class="content">Transporter returns</div></router-link>
<!--        <router-link to="/guestlogins" class="card"><div class="content">Guest logins</div></router-link> -->
        <router-link to="/offlinejobs" class="card"><div class="content">Offline Jobs</div></router-link>
        <router-link to="/logout" class="card"><div class="content">Logout</div></router-link>
      </div>
      <div style="margin-top:2em">version: {{ buildTimestampUTC }}</div>
      <div><button class="ui primary button" @click="postMsg()"></button></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'MainmenuBar',
    data() {
      return {
        sessionread:false,
        buildTimestampUTC: null
      }
    },
    methods: {
      postMsg() {
        this.$swpost('title', 'message');
      },
      readSession() {
        var thiz=this;
        if (!this.sessionread && navigator.onLine) {
          fetch(this.$host+'/session', {
            method:'POST',
            headers: {'Content-type':'application/json'},
            body: '{}',
            credentials:'include',
            mode:'cors'
          }).then(res=>res.json()).then(res=>{
            if (res.error) {
              thiz.$router.push({path:'logout', params:{message:res.error}});
            }
          }).catch(err=>{
            console.log('error:',err);
            
          });
        }
        else {
          setTimeout(()=>{thiz.readSession();thiz=null;}, 1000);
        }
      }
    },
    mounted() {
      const htmlElement = document.documentElement;
      this.buildTimestampUTC = htmlElement.getAttribute('data-build-timestamp-utc');
      this.readSession();
    }
  }

/*
- need to check lisa shield's inspections
- fenders to be named as wing
- check if the sales website works with the photo shoot pictures or not
- "my last inspections" to show the last 24h inspections only and then next page...
- "my last inspections" have a checkbox to see only my inspections or everyone's
** in ccs - view or edit vehicle to show images if there's any (just like layout editor)
*/

</script>
